const Space = (props) => {
  const { children, size = 12, className = '', align = 'start', justify = 'start', style, ...otherProps } = props;

  return (
    <div {...otherProps} style={{ gap: size, ...style }} className={`barbr-space flex ${align} ${justify} ${className}`}>
      {children}
    </div>
  );
};

export default Space;
